import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type BvMetricsService from 'volta/services/bv-metrics';
interface IArgs {
  entityType?: string;
  entityId?: string;
  userId?: string;
}
export default class ActivityCenter extends Component<IArgs> {
  @service bvMetrics!: BvMetricsService;

  @tracked isPopoverVisible: boolean = false;

  @action
  togglePopover() {
    this.bvMetrics.trackAction(this, 'togglePopover');
    if (this.isPopoverVisible) {
      this.hidePopover();
    } else {
      this.showPopover();
    }
  }

  @action
  showPopover() {
    this.isPopoverVisible = true;
  }

  @action
  hidePopover() {
    this.isPopoverVisible = false;
  }
}
